<template>
  <div class="loadingProcess" :class="{ 'ac-bg-black': ac }">
    <header-component
      :is-soon="false"
      img-left=""
      img-right="/trocachip/img/access.png"
      class="header-component"
      :backRoute="false"
    />
    <div class="change_chip_container">
      <img src="img/validation-carousel/check-success.png" />
      <div class="loadingProcess_description">
        <span v-html="loadingProcess.description"></span>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import { mapState } from "vuex";
import trackEvent from "@/services/trackEvent";

export default {
  name: "loadingProcess",
  components: {
    HeaderComponent,
  },
  created() {
    this.sendTracker("screen_etapa_processamento_sucesso");
	window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
    let install_path = !this.config.newInstallation ? "install_esim" : "connectToWifi"
    console.log(this.listMsisdnTestIphone);
    if (this.listMsisdnTestIphone && this.listMsisdnTestIphone.includes(this.customer.login)) {
      setTimeout(
        () => this.$router.push({ name: "install_esim_teste" }),
        this.loadingProcess.timeout
      );
    } else {
      setTimeout(
        () => this.$router.push({ name: install_path}),
        this.loadingProcess.timeout
      );
    }
  },
  data() {
    return {
      description: "",
    };
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      loadingProcess: (state) => state.config.loadingProcess || {},
      customer: (state) => state.customer,
      listMsisdnTestIphone: (state) => state.config.listMsisdnTestIphone,
      config: (state) => state.config
    }),
  },
  methods: {
    sendTracker(eventLabel) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": 6,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": 3,
      });
    },
  },
};
</script>

<style lang="scss">
.loadingProcess {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  .change_chip_container {
    width: 90%;
    height: auto;
    margin: 0 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: content-box;
    > img {
      margin-top: 300px;
      max-height: 35px;
    }
  }
  .loadingProcess_description {
    width: 309px;
    min-height: 48px;
    margin: 16px auto 23px auto;
    display: block;
    position: relative;
    font-family: "timsans_regular";
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    > span {
      width: 309px;
      height: 48px;
      font-size: 18px;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #696969;
    }
  }
}
</style>
